/**
 * DYNAMIC CTA SECTION
 * Adapts messaging and theme based on current site
 * Links to main site (drdnreddyortho.com) in same tab for seamless experience
 */

import React from 'react';
import { Button } from './ui/button';
import { Phone, Calendar, ArrowRight } from 'lucide-react';
import { useSite } from '../contexts/SiteContext';

export const CTASection = ({ title, description, variant = 'default' }) => {
  const { theme, doctor, bodyPart, specialtyLabel } = useSite();
  
  const isDark = variant === 'dark';
  const bgStyle = isDark 
    ? { backgroundColor: '#111827' } // gray-900
    : { backgroundColor: theme.lightBgHex };

  const defaultTitle = `Consult ${doctor.name} – ${specialtyLabel}`;
  const defaultDescription = `Get expert diagnosis and personalized treatment for your ${bodyPart.toLowerCase()} condition. Book your consultation today.`;

  return (
    <section style={bgStyle} className={`py-16 ${isDark ? 'text-white' : ''}`}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            {title || defaultTitle}
          </h2>
          <p className={`text-lg mb-8 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
            {description || defaultDescription}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href={doctor.consultationLink}>
              <Button 
                size="lg" 
                style={{ backgroundColor: theme.primaryHex }}
                className="text-white hover:opacity-90"
                data-testid="cta-book-appointment"
              >
                <Calendar className="w-5 h-5 mr-2" />
                Consult Dr. Reddy
              </Button>
            </a>
            <a href={`tel:${doctor.phone}`}>
              <Button 
                size="lg" 
                variant="outline" 
                style={{ 
                  borderColor: theme.primaryHex, 
                  color: isDark ? 'white' : theme.primaryHex 
                }}
                className={isDark ? 'hover:bg-white/10' : 'hover:bg-opacity-10'}
                data-testid="cta-call-now"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call Now
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </a>
          </div>
          <p className="text-sm mt-6 text-gray-500">
            Visit drdnreddyortho.com for appointments and complete profile
          </p>
        </div>
      </div>
    </section>
  );
};
